import { createContextLocalStore } from 'stores/local/createContextLocalStore';

import { MeetingUpdateDrawerModal } from './MeetingUpdateDrawerModal';

const { Provider, useStore } = createContextLocalStore(MeetingUpdateDrawerModal);

export {
  Provider as MeetingUpdateDrawerModalProvider,
  useStore as useMeetingUpdateDrawerModal,
  MeetingUpdateDrawerModal,
};
